import { Divider as MuiDivider } from '@mui/material';

/** Divider — thin MUI wrapper. Horizontal by default. */
const Divider = (props) => <MuiDivider {...props} />;

export default Divider;
